export default "//static.tradera.net/touchweb/static/output/images/push-wishlist-icon.77df35d5.svg";